import { useEffect } from 'react'

type OneTrustGlobals = {
  getCookie: (name: string) => void
  reloadOTBanner: () => void
} & Window &
  typeof globalThis

const _global = (window || globalThis) as OneTrustGlobals

export const useOneTrust = () => {
  useEffect(() => {
    //@ts-expect-error
    const OneTrust = window.OneTrust // Added to prevent ESLint error

    _global.getCookie = (name: string) => {
      var value = '; ' + document.cookie
      var parts = value.split('; ' + name + '=')
      if (parts.length == 2) {
        return true
      }
    }

    _global.reloadOTBanner = () => {
      var otConsentSdk = document.getElementById('onetrust-consent-sdk')
      if (otConsentSdk) {
        otConsentSdk.remove()
      }

      if (OneTrust) {
        OneTrust.Init()

        setTimeout(() => {
          OneTrust.LoadBanner()

          var toggleDisplay = document.getElementsByClassName(
            'ot-sdk-show-settings',
          )

          for (var i = 0; i < toggleDisplay.length; i++) {
            //@ts-expect-error
            toggleDisplay[i].onclick = (event) => {
              event.stopImmediatePropagation()
              OneTrust.ToggleInfoDisplay()
            }
          }
        }, 1000)
      }
    }
  }, [])
}
